'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  container: {
    display: 'flex',
    flex: '1 0 auto',
    height: '100%'
  },
  container__isScrollable: {
    overflowX: 'scroll',
    maxWidth: '100%',
    position: 'absolute',
    top: 0,
    paddingBottom: 15
  }
};